import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { buildParams } from "../../utils/admin-utils";
import { formatNetSalesResponse } from "../../utils/net-sales-utils";

export function useNetSales() {
	const [netSales, setNetSales] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchNetSales(pagination = {}, filters = {}) {
		try {
			setLoading(true);
			setError(null);

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const params = buildParams(pagination);

			if (filters.idSegmentacao) {
				params.append("idSegmentacao", filters.idSegmentacao);
			}

			const requestOptions = {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				}
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/objetivos?${params.toString()}`,
				requestOptions
			);

			if (!response.ok) {
				await throwResponseError(response, "Erro ao buscar metas Net Sales.");
			}

			const data = await response.json();
			const netSalesData = data.resultado || [];

			const responsePagination = {
				totalElements: data.totalElementos ?? 0,
				totalPages: data.totalPaginas ?? 0,
				page: data.pagina ?? 0,
				size: data.tamanho ?? pagination.size ?? 10
			};

			const formattedNetSales = Array.isArray(netSalesData)
				? netSalesData.map(formatNetSalesResponse)
				: [];

			setNetSales(formattedNetSales);

			return {
				ok: true,
				empty: formattedNetSales.length === 0,
				netSales: formattedNetSales,
				pagination: responsePagination
			};
		} catch (requestError) {
			setNetSales([]);
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		netSales,
		loading,
		error,
		refetch: fetchNetSales
	};
}